import React from 'react'
import Button from '../ButtonBase/Button'
import { ButtonPreviousStepProps } from './ButtonPreviousStepProps'
import useTextContents from 'common/hooks/useTextContents'

import './ButtonPreviousStepStyles.scss'

/**
 * Przycisk "Wstecz" na formularzu, obsługujący logikę powrotu do poprzedniego kroku.
 */
const ButtonPreviousStep = (props: ButtonPreviousStepProps): JSX.Element | null => {
   const buttonTextContents = useTextContents()
   
   const handlePreviousStepButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      
      if(props.previousStepUrlPath !== undefined) {
         props.navigate(props.previousStepUrlPath)
      }
   }

   if(!props.canStepBack || props.previousStepUrlPath === undefined) {
      return null
   }
 
   return (
      <Button
         buttonContent={buttonTextContents('buttons.buttonPreviousStep')} 
         className='page-application-prev-button'
         onClick={(e: React.MouseEvent<HTMLButtonElement>) => handlePreviousStepButtonClick(e)}
      />
   )
}

export default ButtonPreviousStep